import { MISCELLANEOUS_RESOURCES, MISCELLANEOUS_SCOPES, PAGE_NAMES } from 'constant';

export const makeActionList = (params: any) => {
	const { hasPermission } = params;

	return {
		bulkActions: [],
		rowActions: [
			{
				name: 'Edit',
				id: 'edit',
				isEnabled: () => {
					return hasPermission({
						configPageName: PAGE_NAMES.miscellaneous,
						configResourceName: MISCELLANEOUS_RESOURCES.messageCenter,
						configActionName: MISCELLANEOUS_SCOPES[MISCELLANEOUS_RESOURCES.messageCenter].updateMessageCenterCard
					});
				}
			}
		],
		addAction: {
			name: 'Add',
			id: 'add',
			isEnabled: () => {
				return hasPermission({
					configPageName: PAGE_NAMES.miscellaneous,
					configResourceName: MISCELLANEOUS_RESOURCES.messageCenter,
					configActionName: MISCELLANEOUS_SCOPES[MISCELLANEOUS_RESOURCES.messageCenter].createMessageCenterCard
				});
			}
		}
	};
};

export default {
	makeActionList
};
